import { useState, useEffect } from 'react';
import { Box, Table, TableBody, TableHead, TableRow, MenuItem } from '@mui/material';
import {
  HeadTableCell,
  RowTableCell,
  CustomButton,
  CustomSelect,
  DialogBody,
  GeneralTableBox,
  NoDataSkeleton,
  ActionIconButton,
} from '../../../common/components';

import PostAddIcon from '@mui/icons-material/PostAdd';

import PaymentMethodDetailDialog from '../dialogs/PaymentMethodDetailDialog';

const PaymentMethodDetailsTab = ({
  data,
  paymentMethods,
  fees,
  selectedItem,
  dialogOpen,
  editMode,
  selectedPlan,
  handleAdd,
  handleEdit,
  handleDelete,
  handleClose,
  handleSave,
}) => {
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);
  const [filteredPaymentMethodDetails, setFilteredPaymentMethodDetails] = useState([]);

  useEffect(() => {
    if (paymentMethods.length > 0 && selectedPlan) {
      const firstPaymentMethod = paymentMethods.find(
        (paymentMethod) => paymentMethod.uuid_plan === selectedPlan.uuid
      );

      if (firstPaymentMethod) {
        setSelectedPaymentMethod(firstPaymentMethod);
        const newFilteredDetails = data.filter(
          (paymentMethodDetail) =>
            paymentMethodDetail.uuid_payment_method === firstPaymentMethod.uuid
        );
        setFilteredPaymentMethodDetails(newFilteredDetails);
      }
    }
  }, [paymentMethods, selectedPlan, data]);

  const handleSelectChange = (event) => {
    setSelectedPaymentMethod(event.target.value);
    setFilteredPaymentMethodDetails(
      data.filter(
        (paymentMethodDetail) => paymentMethodDetail.uuid_payment_method === event.target.value.uuid
      )
    );
  };

  const handleAddWithOrder = () => {
    const maxOrder = Math.max(
      ...filteredPaymentMethodDetails.map((detail) => detail.item_order),
      0
    );

    handleAdd({
      item_order: maxOrder + 1,
      uuid_payment_method: selectedPaymentMethod?.uuid,
    });
  };

  return (
    <DialogBody sx={{ p: 2, minHeight: '65vh' }}>
      <Box sx={{ mt: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2 }}>
          <CustomButton variant="base" onClick={handleAddWithOrder} buttonIcon={PostAddIcon}>
            Agregar
          </CustomButton>
          <CustomSelect
            label={'Formas de pago'}
            labelId="paymentMethod-label"
            name="paymentMethod"
            onChange={handleSelectChange}
            value={selectedPaymentMethod || ''}
            size="medium"
            sx={{ minWidth: 200, maxWidth: 300 }}
          >
            {paymentMethods
              .filter((paymentMethod) => paymentMethod.uuid_plan === selectedPlan?.uuid)
              .map((paymentMethod, index) => (
                <MenuItem key={index} value={paymentMethod}>
                  {paymentMethod.name}
                </MenuItem>
              ))}
          </CustomSelect>
        </Box>
        <GeneralTableBox>
          {filteredPaymentMethodDetails.length > 0 ? (
            <Table>
              <TableHead>
                <TableRow>
                  <HeadTableCell>Orden</HeadTableCell>
                  <HeadTableCell>Tipo Cuota</HeadTableCell>
                  <HeadTableCell>Acciones</HeadTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filteredPaymentMethodDetails
                  .sort((a, b) => a.item_order - b.item_order)
                  .map((paymentMethodDetail) => (
                    <TableRow key={paymentMethodDetail.id}>
                      <RowTableCell>{paymentMethodDetail.item_order}</RowTableCell>
                      <RowTableCell>
                        {fees.find(fee => fee.uuid === paymentMethodDetail.uuid_fee)?.name}
                      </RowTableCell>
                      <RowTableCell>
                        <ActionIconButton
                          variant="edit"
                          onClick={() => handleEdit(paymentMethodDetail)}
                        />
                        <ActionIconButton
                          variant="delete"
                          onClick={() => handleDelete(paymentMethodDetail.uuid)}
                        />
                      </RowTableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          ) : (
            <NoDataSkeleton />
          )}
        </GeneralTableBox>
      </Box>

      <PaymentMethodDetailDialog
        open={dialogOpen}
        onClose={handleClose}
        onSave={(data) =>
          handleSave({
            ...data,
            uuid_payment_method: selectedPaymentMethod?.uuid,
          })
        }
        selectedItem={selectedItem}
        editMode={editMode}
        fees={fees.filter((fee) => fee.uuid_plan === selectedPlan?.uuid)}
      />
    </DialogBody>
  );
};

export default PaymentMethodDetailsTab;
